module.exports = __webpack_public_path__ + "img/cloud.775ad4d1.svg";